angular.module('env.data.rest.signalR.signalRHub', [])

    .factory('SignalRHub', function ($timeout, $q, $log) {
        //This will allow same connection to be used for all Hubs
        //It also keeps connection as singleton.
        var globalConnections = [];

        function initNewConnection(options) {
            var connection = null;
            try {
                if (options && options.rootPath) {
                    connection = $.hubConnection(options.rootPath, {useDefaultPath: false});
                } else {
                    connection = $.hubConnection();
                }
                connection.logging = (options && options.logging ? true : false);
            } catch (e) {
                $log.error("SignalR connection error", e);
            }
            return connection;
        }

        function getConnection(options) {
            var useSharedConnection = !(options && options.useSharedConnection === false);
            if (useSharedConnection) {
                return typeof globalConnections[options.rootPath] === 'undefined' ?
                    globalConnections[options.rootPath] = initNewConnection(options) :
                    globalConnections[options.rootPath];
            } else {
                return initNewConnection(options);
            }
        }

        return function (hubName, options) {
            var Hub = this;
            var connectionPromise;

            Hub.connection = getConnection(options);
            Hub.proxy = Hub.connection.createHubProxy(hubName);

            Hub.on = function (event, fn) {
                Hub.proxy.on(event, fn);
            };
            Hub.invoke = function (method, args) {
                return Hub.proxy.invoke.apply(Hub.proxy, arguments)
            };
            Hub.disconnect = function () {
                Hub.connection.stop();
            };
            Hub.connect = function () {
                if (Hub.connection.state == $.signalR.connectionState.connected) {
                    return $q.when(Hub.connection);
                } else if (Hub.connection.state == $.signalR.connectionState.connecting ||
                    Hub.connection.state == $.signalR.connectionState.reconnecting) {
                    return connectionPromise;
                } else if (Hub.connection.state == $.signalR.connectionState.disconnected) {
                    try {
                        connectionPromise = Hub.connection.start(options.transport
                            ? {transport: options.transport}
                            : null);
                        return connectionPromise;
                    } catch (e) {
                        $log.error("SignalR connection error", e);
                        return $q.reject("SignalR connection error: " + e.toString());
                    }
                }
                $log.error("SignalR connection error: unknown state");
                return $q.reject("SignalR connection error: unknown state");
            };

            Hub.connection.stateChanged(function (change) {
                if (change.newState == $.signalR.connectionState.connected) {
                    if (options.onSignalRConnected && _.isFunction(options.onSignalRConnected)) {
                        options.onSignalRConnected();
                    }
                }

                $log.debug("SignalR state changed. New state: %s. Old state: %s",
                    connectionStateToString(change.newState),
                    connectionStateToString(change.oldState));
            });

            function connectionStateToString(code) {
                try {
                    if (code === $.signalR.connectionState.connected) {
                        return "connected";
                    } else if (code === $.signalR.connectionState.connecting) {
                        return "connecting";
                    } else if (code === $.signalR.connectionState.reconnecting) {
                        return "reconnecting";
                    } else if (code === $.signalR.connectionState.disconnected) {
                        return "disconnected";
                    }
                } catch (e) {
                }
                return "unknown (code: " + code + ")";
            }

            Hub.ensureConnection = function () {
                try {
                    return Hub.connect();
                } catch (e) {
                    $log.error("SignalR hub ensure connection error", e);
                    return $q.reject("SignalR hub ensure connection error: " + e.toString());
                }
            };

            if (options && options.listeners) {
                angular.forEach(options.listeners, function (fn, event) {
                    Hub.on(event, fn);
                });
            }
            if (options && options.methods) {
                angular.forEach(options.methods, function (method) {
                    Hub[method] = function () {
                        var args = $.makeArray(arguments);
                        args.unshift(method);
                        return Hub.invoke.apply(Hub, args);
                    };
                });
            }
            if (options && options.queryParams) {
                Hub.connection.qs = options.queryParams;
            }
            if (options && options.errorHandler) {
                Hub.connection.error(options.errorHandler);
            }

            if (options && options.autoReconnect) {
                Hub.connection.disconnected(function () {
                    $timeout(function () {
                        Hub.connect();
                    }, options.autoReconnectTimeout || 5000); // Restart connection after 5 seconds.
                });
            }

            Hub.connect();

            return Hub;
        };
    })
;
